import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  // getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../locales/locales';
import { LinkResponseDto } from '../../../store/landscapeAPI/link/dto/response/link-response.dto';
import { LinkEntityType } from '../../../store/landscapeAPI/link/link-entity-type';
import {
  saveLink,
  // updateLink,
} from '../../../store/landscapeAPI/link/reducers/link.slice';
import { AppDispatch, RootState } from '../../../store/store';
import { PromiseSettledResult } from '../../../utils/types/types';
import { getUUID } from '../../../utils/UUID';
import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeIndicatorExternalResourceAddTemplate } from '../../templates';

interface LandscapeIndicatorExternalResourceAddPageProps {}

const LandscapeIndicatorExternalResourceAddPage: FC<
  LandscapeIndicatorExternalResourceAddPageProps
> = () => {
  const { id, landscapeIndicatorId } = useParams();

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [externalResource, setExternalResource] = useState<LinkResponseDto>({
    title: '',
    entityType: LinkEntityType.CompactIndicator,
    compactId: id!,
    entityId: landscapeIndicatorId!,
    url: '',
    description: '',
    date: '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { status } = useSelector((state: RootState) => state.linkSlice);

  const [selectedLanguage, setLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [fromLanguage, setFromLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [toLanguage, setToLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const generateAllTranslations: () => Promise<
    PromiseSettledResult<void>[]
  > = async () => {
    const rejectedResults: PromiseSettledResult<void>[] = [
      {
        status: 'rejected',
        reason: new Error(
          'Must save verification status before generating translation'
        ),
      },
    ];

    return Promise.reject(rejectedResults);
  };

  const generateTranslation = async () => {};

  const handleAddExternalResource = async (
    externalResource: LinkResponseDto
  ) => {
    await dispatch(saveLink(externalResource));
    navigate(
      `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/external-resources`
    );
  };

  const handleExternalResourceChange = (externalResource: LinkResponseDto) => {
    setExternalResource(externalResource);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeIndicatorExternalResourceAddTemplate
      externalResource={externalResource}
      handleExternalResourceChange={handleExternalResourceChange}
      handleAddExternalResource={handleAddExternalResource}
      setLanguage={setLanguage}
      selectedLanguage={selectedLanguage}
      fromLanguage={fromLanguage}
      setFromLanguage={setFromLanguage}
      toLanguage={toLanguage}
      setToLanguage={setToLanguage}
      generateTranslation={generateTranslation}
      generateAllTranslations={generateAllTranslations}
    />
  );
};

export default LandscapeIndicatorExternalResourceAddPage;
